import microuniversoApi from "app/api/microuniversoApi";
import { RespostaCadastroCliente } from "app/types/cliente/RespostaCadastroCliente";
import { ICidade } from "app/types/ICidade";
import { ICliente } from "app/types/ICliente";
import { IVendedor } from "app/types/IVendedor";
import { Bairro } from "app/types/NovoEndereco";
import { tratamentoErroPadrao } from "app/use-cases";
import { FormikErrors } from "formik";
import globalMU from "globalMU";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { DadosBasicosCliente } from "./DadosBasicosCliente";
import { IEndereco } from "app/types/IEndereco";
import { ParametroPorItem } from "app/types/Parametro";
import { obterParametrosPorOidItem } from "app/use-cases/parametro/obterParametros";

export type DadosBasicosClienteContainerProps = {
  somenteLeitura: boolean
  foraOrcamento?: boolean // 414608
  tipoOrcamento?: 0 | 1 | 2 | 3; // 414608
  IdentificadorOrcamento?: string // 414608
  oidFilial?: number // 414608 pixPrazo
  permiteEditarCpfCnpj?: boolean
  dadosCliente: RespostaCadastroCliente
  permiteAlterarNomeRazaoSocial: boolean
  permitirAlterarDadosBasicos: boolean
  usuarioPermitidoAlterarVendedorRelacionado: boolean
  utilizarBairrosPreCadastrados: boolean
  formularioValidado: boolean;
  permiteEditarEnderecoComercial: boolean // 465680
  // 493933 ocultarCelularEContato?: boolean // 490808 - aba "Dados Cliente" é dona desses campos (I2)
  manterDadosTemporariosCliente: (ICliente: ICliente) => void;
  onValidarFormulario: (formularioValidado: boolean) => void;
  onErrorValidacao: (erros: FormikErrors<ICliente>) => void;
  onAlterarEnderecoComercial: (endereco: IEndereco) => void;
}

export const DadosBasicosClienteContainer = (props: DadosBasicosClienteContainerProps) => {
  const [cidades, setCidades] = useState<ICidade[]>([]);
  const [bairros, setBairros] = useState<Bairro[]>([]);
  const [vendedor, setVendedor] = useState<IVendedor[]>([]);
  const [parametrosPorFilial, setParametrosPorFilial] = useState<ParametroPorItem[]>([])
  const isMounted = useRef(true)
    


  const onObterEnderecoPorCepCliente = async (cep: string, cliente: ICliente) => {
    if (!isMounted.current) return
    cep = cep.replace(/\D/g, "") // Remove caracteres não numéricos
    if (cep.length <= 0) {
        return
    }
    try {
      globalMU.blockUI();
      const enderecoRetornado = await microuniversoApi.Comum.obterEnderecoPorCep(cep?.trim());

      if (!("HasErrors" in enderecoRetornado) && enderecoRetornado.Cep != null) {
        if (!isMounted.current) return
        props.manterDadosTemporariosCliente({
          ...props.dadosCliente.Cliente,
          Endereco: enderecoRetornado.Logradouro,
          Bairro: enderecoRetornado.Bairro,
          Cep: enderecoRetornado.Cep,
          Cidade: enderecoRetornado.Cidade,
          Estado: enderecoRetornado.Estado,
          NomeCidade: enderecoRetornado.NomeCidade,
          CodigoCidade: enderecoRetornado.CodigoCidade,
          SiglaUf: enderecoRetornado.SiglaUf,
          CodigoEstado: enderecoRetornado.CodigoEstado
        })
        if (!isMounted.current) return
        props.onAlterarEnderecoComercial({
          Logradouro: enderecoRetornado.Logradouro,
          Cep: enderecoRetornado.Cep,
          CodigoEstado: enderecoRetornado.CodigoEstado,
          Bairro: enderecoRetornado.Bairro,
          CodigoCidade: enderecoRetornado.CodigoCidade,
          NomeCidade: enderecoRetornado.NomeCidade,
          Cidade: enderecoRetornado.Cidade,
          Estado: enderecoRetornado.Estado,
          SiglaUf: enderecoRetornado.SiglaUf,
          Referencia: cliente.Referencia,
          Numero: cliente.NumeroEndereco,
          Complemento: cliente.ComplementoEndereco,
        })

        onListarCidadesPorEstadoCliente(enderecoRetornado.Estado?.Codigo);
        onListarBairros(enderecoRetornado.Bairro);
      }

    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onListarCidadesPorEstadoCliente = useCallback(async (codigo: number) => {
    if (!isMounted.current) return
    if (codigo === undefined || codigo <= 7) return;
    
    globalMU.blockUI();
    try {
      const cidadesRetornadas = await microuniversoApi.Comum.listarCidadesPorEstado(codigo);
      if (!isMounted.current) return
      setCidades(cidadesRetornadas?.map((cidade) => cidade));
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, []);
  
  const obterParametros = async () => {
    
    if (!isMounted.current) return
    const paramFilial = await obterParametrosPorOidItem({
      nomes: [
        "TRABALHA_COBRANCA_PIX_PRAZO", // 414608 pixPrazo
      ],
      oidItem: props.oidFilial ?? 0
    });
    setParametrosPorFilial(paramFilial)
  }

  const valorParametroPorFilial = (nome: string) => parametrosPorFilial.find((p) => p.Nome == nome)?.Valor
  

  const onAlteradoCPFCNPJ = async (cpfCnpj: string) => {
    if (!isMounted.current) return
    try {
      globalMU.blockUI();
      const obrigatorioInformarEmail = await microuniversoApi.Cliente.obrigatorioInformarEmail(cpfCnpj)

      const tipoPessoa = await microuniversoApi.Comum.ObterTIpoPessoa(cpfCnpj, true)

      tipoPessoa == "J" || tipoPessoa == "F" ?
        props.manterDadosTemporariosCliente({
          ...props.dadosCliente.Cliente,
          CpfCnpj: cpfCnpj,
          PessoaJuridica: tipoPessoa == "J",
          EmailObrigatorio: obrigatorioInformarEmail
        })
        : (
          globalMU.showErrorMessage(tipoPessoa),
          props.manterDadosTemporariosCliente({
            ...props.dadosCliente.Cliente,
            CpfCnpj: ""
          })
        )

    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }

  const onListarBairros = useCallback(async (bairro: string) => {
    if (!isMounted.current) return
    if (!props.utilizarBairrosPreCadastrados) return;
    
    globalMU.blockUI();
    try {
      const bairros = await microuniversoApi.Comum.listarBairrosPreCadastrados(bairro);
      if (!isMounted.current) return
      setBairros(bairros);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, [props.utilizarBairrosPreCadastrados]);
  
  const onAlterarEmailPixPrazoNoOrcamento = async (emailPixPrazo: string) => { // 414608
    
    if (!props.foraOrcamento || !props.IdentificadorOrcamento || props.tipoOrcamento !== 0) return
    if (!isMounted.current) return
    await microuniversoApi.Orcamento.alterarEmailPixPrazoNoOrcamento(props.IdentificadorOrcamento, emailPixPrazo);
  }

  const onPesquisarVendedoresPorNome = useCallback(async (nomeCodigoVendedor: string) => {
    if (!isMounted.current) return
    globalMU.blockUI();
    try {
      const vendedoresPesquisados = await microuniversoApi.Pessoa.listarVendedoresPorNome(nomeCodigoVendedor);
      if (!isMounted.current) return
      setVendedor(vendedoresPesquisados);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  }, []);
  

  const onManterDadosTemporarios = (dados: ICliente) => { props.manterDadosTemporariosCliente(dados) }

  useEffect(() => {
    if (!isMounted.current) return
    obterParametros()
  }, [props.oidFilial])
 
  useEffect(() => {
      return () => {
        isMounted.current = false
      }
    }, [])

  useEffect(() => {
    props?.dadosCliente != null && props?.dadosCliente?.Cliente != null 
          && props?.dadosCliente?.Cliente?.CodigoEstado != null 
          && props?.dadosCliente?.Cliente?.CodigoEstado > 7
      onListarCidadesPorEstadoCliente(props?.dadosCliente?.Cliente?.CodigoEstado ?? 0)
  },[props.dadosCliente?.Cliente?.CodigoEstado])

  return (
    <div className="_mt-8">
      <DadosBasicosCliente
        somenteLeitura={props.somenteLeitura}
        foraOrcamento={props.foraOrcamento} // 414608
        tipoOrcamento={props.tipoOrcamento} // 414608
        permiteEditarCpfCnpj = {props.permiteEditarCpfCnpj}
        usaClienteMais={props.dadosCliente?.NomeDadoAdicionalClienteMais}
        permiteAlterarNomeRazaoSocial={props.permiteAlterarNomeRazaoSocial}
        cliente={props.dadosCliente?.Cliente}
        vendedores={vendedor}
        uf={props.dadosCliente?.Estados}
        cidades={cidades}
        segmentos={props.dadosCliente?.Segmentos}
        utilizarBairrosPreCadastrados={props.utilizarBairrosPreCadastrados}
        permitirAlterarDadosBasicos={props.permitirAlterarDadosBasicos}
        usuarioPermitidoAlterarVendedorRelacionado={props.usuarioPermitidoAlterarVendedorRelacionado}
        formularioValidado={props.formularioValidado}
        paramTRABALHA_COBRANCA_PIX_PRAZO={valorParametroPorFilial("TRABALHA_COBRANCA_PIX_PRAZO")=="S"} // 414608 pixPrazo
        bairros={bairros}
        utilizarVendedorRelacionado={props.dadosCliente?.UsuarioPermitidoAlterarVendedorRelacionado}
        permiteEditarEnderecoComercial={props.permiteEditarEnderecoComercial} // 465680
        //493933 ocultarCelularEContato={props.ocultarCelularEContato} // 490808
        onPesquisarCep={onObterEnderecoPorCepCliente}
        onListarBairros={onListarBairros}
        onListarCidadesPorEstado={onListarCidadesPorEstadoCliente}
        manterDadosTemporarios={onManterDadosTemporarios}
        onPesquisarVendedorRelacionado={onPesquisarVendedoresPorNome}
        onErrorValidacao={props.onErrorValidacao}
        onValidarFormulario={props.onValidarFormulario}
        onAlteradoCPFCNPJ={onAlteradoCPFCNPJ}
        onAlterarEnderecoComercial={props.onAlterarEnderecoComercial}
        onAlterarEmailPixPrazoNoOrcamento={onAlterarEmailPixPrazoNoOrcamento} // 414608
      />
    </div>
  );
};
